<template>
    <v-container fluid ma-0 pb-0>
        <template  v-if="type !== 'details'">
            <v-toolbar flat color="white">
                <!--Client FORM-->
                <template v-if="type === 'form'">
                    <v-toolbar-title >{{ formTitle }}</v-toolbar-title>
                </template>
                <!--Client VIEW TABLE-->
                <template v-if="type === 'view'">
                    <v-toolbar-title>
                        Clients Table
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <template v-if="Array.isArray(chartSeries) && chartSeries.length">
                        <v-label>Types Breakdown</v-label>
                        <headerChartBar :cSeries="chartSeries"></headerChartBar>
                        <v-spacer></v-spacer>
                    </template>

                    <responsiveButton setTo="/orgWorkSpace/client/add"
                                      setColor="blue"
                                      setDefaultIcon="mdi-plus"
                                      setSmallIcon="mdi-plus-circle-outline"
                    >
                        Add Client
                    </responsiveButton>
                </template>
                <!--Client DocumentFile-->
                <template v-if="type === 'documentFile'">
                    <v-toolbar-title>Edit client document files</v-toolbar-title>
                </template>
                <!--Client type-->
                <template v-if="type === 'addType'">
                    <v-toolbar-title>Client Categories Table </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <responsiveButton setTo="/orgWorkSpace/group-type/client/add/"
                                      setColor="blue"
                                      setDefaultIcon="mdi-plus"
                                      setSmallIcon="mdi-plus-circle-outline"
                    >
                        Add Client Category
                    </responsiveButton>
                </template>
            </v-toolbar>
            <v-divider class="my-0 mx-6"></v-divider>
        </template>
        <!--Details View-->
        <template v-else>
            <v-row align="center">
                <v-col class="pb-0">
                    <v-card elevation="1">
                        <v-card-actions>
                            <v-bottom-navigation
                                    grow
                                    class="elevation-0"
                                    :value="activeBtn"
                                    color="blue"
                            >
                                <v-btn
                                        :to="{name:CLIENTS.DOCUMENTS.route}">
                                    <span>{{CLIENTS.DOCUMENTS.text}}</span>
                                    <v-icon>{{CLIENTS.DOCUMENTS.icon}}</v-icon>
                                </v-btn>

                                <v-btn
                                        :to="{name:CLIENTS.EMPLOYEES.route}">
                                    <span>{{CLIENTS.EMPLOYEES.text}}</span>
                                    <v-icon>{{CLIENTS.EMPLOYEES.icon}}</v-icon>
                                </v-btn>

                                <v-btn
                                        :to="{name: CLIENTS.REPORTS.route}">
                                    <span>{{CLIENTS.REPORTS.text}}</span>
                                    <v-icon>{{CLIENTS.REPORTS.icon}}</v-icon>
                                </v-btn>
                            </v-bottom-navigation>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {CLIENTS} from '@/shared/enums/SubViewPathName';
    const responsiveButton = () => import('@/components/common/mobile/Button');
    const headerChartBar = () => import('@/components/orgApps/charts/headerChartBars');
    const clientHeaderDetails = () => import('@/components/orgApps/Client/ClientHeaderDetails');

    export default {
        name: "ClientHeader",
        components: {
            responsiveButton,
            headerChartBar,
            clientHeaderDetails
        },
        props:["hType","hId"],
        data(){
            return{
                type: this.hType,
                path_id: this.hId,
                activeBtn: this.selectSubView(),
                chartSeries: []
            }
        },
        computed:{
            formTitle () {
                return this.id !== undefined ? 'Edit client' : 'New client';
            },
            CLIENTS(){
                return CLIENTS;
            }
        },
        methods: {
            async getClientsChart() {
                let details = this.$store.getters['getClientDetails'];
                // if empty
                if (
                  details !== null ||
                  (Object.keys(details).length === 0 && details.constructor === Object)
                ) {
                  //going backend
                  try {
                    await this.$store.dispatch(`getClientDetails`);
                    details = this.$store.getters[`getClientDetails`];
                  } catch (e) {
                    //set alert
                    alertEventBus.setAlert({ type: "error", msg: e.message });
                    return;
                  }
                }

                let dataSeries = [];

                if (!!details && !!details.counters && !!details.counters.typeName) {
                  const { typeName } = details.counters;
                  const reducer = (a, c) => a + c;

                  dataSeries = Object.keys(typeName).map((k) => ({
                    name: k,
                    data: [Object.values(typeName[k].status).reduce(reducer)],
                  }));
                  this.chartSeries = dataSeries;
                }
            },
            selectSubView(){
                if(this.path_view === CLIENTS.DOCUMENTS.text){
                    return 0;
                }

                if(this.path_view == CLIENTS.EMPLOYEES.text){
                    return 1;
                }

                if(this.path_view == CLIENTS.REPORTS.text){
                    return 2;
                }
            }
        },
        async created() {
            this.getClientsChart();
        }
    }
</script>

<style scoped>

</style>